import AdvanceManagement from "components/AdvanceManagement";
import AuthPage from "components/shared/AuthPage";

const AdvanceManagementPage = () => (
    <AuthPage userAuthenticated={true} pageName="advance-management">
        <AdvanceManagement />
    </AuthPage>
);

export default AdvanceManagementPage;
